module.exports = __webpack_public_path__ + "static/media/telefono.fd3de863.svg";